import React from 'react';
import ReactImageLoad from 'react-load-image';
import { Style } from 'radium';
import classnames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';

import FullScreenImage from '../../../../../../../../components/FullScreenImage';
import EditableCaption from '../../../../../../components/EditableCaption';

const onCaptionChange = (itemId, dispatch) => (text) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    caption: text
  });
};

const onParagraphChange = (itemId, dispatch) => (text) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    paragraph: text
  });
};

const editorOptions = {
  disableReturn: true,
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

function renderOverlayCaption(item, editable, dispatch) {
  const paragraph = item.paragraph;
  if (!paragraph && !editable) {
    return null;
  }

  const clonedEditorOptions = cloneDeep(editorOptions);
  Object.assign(clonedEditorOptions, {
    disableReturn: true,
    paste: {
      forcePlainText: true,
      cleanPastedHTML: false
    }
  });

  return (
    <div className="block-overlay__container block-image__container">
      <div>
        <div>
          <EditableCaption
            wrapperClassName="block-image__paragraph brand--linkColor brand--head"
            text={paragraph}
            placeholder="Enter some text"
            editable={editable}
            onChange={onParagraphChange(item._id, dispatch)}
            editorOptions={clonedEditorOptions}
          />
        </div>
      </div>
    </div>
  );
}

function renderCaption(item, editable, dispatch) {
  const caption = item.caption;
  const captionClassSet = classnames('block-image__caption brand--body brand--linkColor', {
    'hide-placeholder': caption
  });
  if (!caption && !editable) {
    return null;
  }
  const clonedEditorOptions = cloneDeep(editorOptions);
  Object.assign(clonedEditorOptions, {
    disableReturn: true,
    paste: {
      forcePlainText: true,
      cleanPastedHTML: false
    }
  });

  return (
    <div className="block-image__container brand--body">
      <EditableCaption
        wrapperClassName={captionClassSet}
        text={caption}
        placeholder="Add a caption"
        component="figcaption"
        editable={editable}
        onChange={onCaptionChange(item._id, dispatch)}
        editorOptions={clonedEditorOptions}
      />
    </div>
  );
}

const BackgroundImage = ({ src, cProps }) => {
  const lesson = cProps.lesson;
  const item = lesson.items[0];

  const media = item.media;
  // const imageSrc = media.image.src;
  const alt = media.image.alt;
  const placeHolder = media.image.placeHolder;

  const settings = lesson.settings;
  const {
    opacity,
    opacityColor,
    paddingBottom,
    paddingTop,
    backgroundColor,
    zoomOnClick
  } = settings;

  const overlayStyle = {
    opacity,
    backgroundColor: opacityColor
  };

  const variant = lesson.variant;
  const isTextOverlay = variant === 'textOverlay';

  const editable = cProps.editable;
  // const dispatch = cProps.dispatch;
  const enableZoom = !editable && !isTextOverlay && zoomOnClick;
  return (
    <div className="block-image__image" alt={alt}>
      <FullScreenImage
        src={src}
        enableZoom={enableZoom}
        alt={alt || ''}
        placeHolder={placeHolder}
        imageAttrs={{
          className: 'visible'
        }}
      />
      <div className="block-image__overlay" style={overlayStyle} />
    </div>
  );
};

export default class FullImage extends React.Component {
  renderImage = (src) => {
    const lesson = this.props.lesson;
    const item = lesson.items[0];
    const media = item.media;
    const alt = media.image.alt;
    const placeHolder = media.image.placeHolder;

    return (
      <ReactImageLoad src={src}>
        <BackgroundImage cProps={this.props} />
        {placeHolder ? (
          <img
            className="placeHolderImage"
            src={placeHolder}
            alt={alt}
            style={{
              maxWidth: '100%',
              width: '100%',
              height: '100%',
              display: 'block',
              filter: 'blur(10px)'
            }}
          />
        ) : (
          <div>error loading image</div>
        )}
        <img
          className="placeHolderImage"
          src={placeHolder}
          alt={alt}
          style={{
            maxWidth: '100%',
            width: '100%',
            height: '100%',
            display: 'block',
            filter: 'blur(10px)'
          }}
        />
      </ReactImageLoad>
    );
  };

  // <img className="visible" src={src} alt={alt || ''} />
  render() {
    const lesson = this.props.lesson;
    const item = lesson.items[0];
    const media = item.media;
    const imageSrc = media.image.src;
    const { editable, dispatch } = this.props;
    const variant = lesson.variant;
    const isTextOverlay = variant === 'textOverlay';
    const variantClassName = isTextOverlay ? 'overlay' : 'full';
    const settings = lesson.settings;

    const {
      opacity,
      opacityColor,
      paddingBottom,
      paddingTop,
      backgroundColor,
      zoomOnClick
    } = settings;

    const style = {
      paddingBottom: paddingBottom * 10,
      paddingTop: paddingTop * 10,
      backgroundColor
    };

    return (
      <div className={`block-image block-image--${variantClassName}`} style={style}>
        <figure className="block-image__figure">
          {this.renderImage(imageSrc)}
          {isTextOverlay ? renderOverlayCaption(item, editable, dispatch) : null}
        </figure>
        {isTextOverlay ? null : renderCaption(item, editable, dispatch)}
        <Style
          rules={{
            '.block-image--overlay .block-image__paragraph p, .block-image--overlay .block-image__paragraph .medium-editor, .block-image--overlay .block-image__paragraph, .block-image--overlay .block-image__paragraph span': {
              fontSize: '32px !important',
              lineHeight: '48px !important',
              fontWeight: '700 !important'
            },
            '.block-image--overlay .block-image__paragraph .medium-editor, .block-image--overlay .block-image__paragraph': {
              color: '#FFF',
              fontWeight: 700
            }
          }}
        />
      </div>
    );
  }
}
